var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.50002C8 6.73301 7.90396 6.96597 7.71229 7.1436L1.67776 12.7333C1.29388 13.0889 0.671503 13.0889 0.287787 12.7333C-0.095929 12.3779 -0.0959291 11.8015 0.287787 11.4459L5.62748 6.50002L0.287973 1.55414C-0.095743 1.19856 -0.095743 0.622221 0.287973 0.266814C0.671689 -0.0889378 1.29407 -0.0889378 1.67794 0.266814L7.71248 5.85645C7.90418 6.03416 8 6.26712 8 6.50002Z",
    fill: "#ABAFB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.fcd73fd720921f8ac55185b0507d73d2.svg";
export { ForwardRef as ReactComponent };